import React, { useState, useContext } from 'react';
import { Box, IconButton, Menu, MenuItem, Avatar, Typography } from '@mui/material';
import { Logout, AccountCircle, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Auth from '../utils/auth';
import { Modal } from '@mui/material';
import ClientBloomFeedbackForm from '../components/Feedback/feedback';
import Roadmap from '../components/Roadmap/roadmap';
import './layout.css';
import { UserContext } from '../utils/UserContext';

const Header = () => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [showFeedback, setShowFeedback] = useState(false);
    const [showRoadmap, setShowRoadmap] = useState(false);
    const { user: contextUser } = useContext(UserContext);
    const user = contextUser;

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        Auth.logout();
        navigate('/login');
    };

    return (
        <header className="header">
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
            />
            <div className="header-container">
                <img src="/cb_logo.png" alt="ClientBloom Logo" className="layout-header-logo" />
                <Box className="header-nav">
                    <nav>
                        <a href="/">Dashboard</a>
                        <a href="/clients">Clients</a>
                        {/* <a href="/surveys">Surveys</a> */}
                        {/* <a href="/reports">Reports</a> */}
                        <a href="/resources">Resources</a>
                        {user && (
                            <Box className="header-profile">
                                {user.admin && <a href="/admin-panel">Admin</a>}
                            </Box>
                        )}
                    </nav>
                </Box>
                {/* Profile Section */}
                {user && (
                    <Box className="header-profile">
                        {/*}
                        <IconButton onClick={() => setShowRoadmap(true)} size="small">
                            <Avatar sx={{ bgcolor: '#fff' }}>
                                <img src="/roadmap.png" alt="Roadmap" style={{ width: 60, height: 60 }} />
                            </Avatar>
                        </IconButton>
                        */}
                        <IconButton onClick={() => setShowFeedback(true)} size="small">
                            <Avatar sx={{ bgcolor: '#fff' }}>
                                <img src="/feedback_form_icon.png" alt="Feedback" style={{ width: 50, height: 50 }} />
                            </Avatar>
                        </IconButton>
                        <IconButton onClick={handleMenuOpen} size="small">                            
                            <Avatar
                                alt={user?.email}
                                src={user?.profileImage?.url}
                                sx={{ width: 40, height: 40 }}
                            >
                                <AccountCircle fontSize="large" />
                            </Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                            <MenuItem disabled>
                                <Typography variant="body2">{user.email}</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                    handleMenuClose();
                                    navigate('/edit-profile');
                                }}>
                                <Edit fontSize="small" sx={{ marginRight: 1 }} />
                                Edit Profile
                            </MenuItem>
                            <MenuItem onClick={handleLogout}>
                                <Logout fontSize="small" sx={{ marginRight: 1 }} />
                                Logout
                            </MenuItem>
                        </Menu>
                    </Box>
                )}
                {/*
                <Modal
                    open={showRoadmap}
                    onClose={() => setShowRoadmap(false)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(3px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1300 
                    }}
                    >
                    <Box
                        sx={{
                        borderRadius: 3,
                        p: 2,
                        maxHeight: '100vh',
                        width: '100%',
                        maxWidth: 650
                        }}
                    >
                        <Roadmap />
                    </Box>
                </Modal>
                */}
                <Modal
                    open={showFeedback}
                    onClose={() => setShowFeedback(false)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(3px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1300 
                    }}
                    >
                    <Box
                        sx={{
                        borderRadius: 3,
                        p: 2,
                        maxHeight: '90vh',
                        width: '90%',
                        maxWidth: 650
                        }}
                    >
                        <ClientBloomFeedbackForm />
                    </Box>
                </Modal>
            </div>
        </header>
    );
};

export default Header;